/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppTemplateDataSchema = z.object({
	id: z.string(),
	name: z.string(),
	language: z.string(),
	category: z.string(),
	status: z.string(),
	components: z.array(z.string()),
	parameterCount: z.number(),
	parameterExamples: z.array(z.string()).nullable(),
	parameterMap: z.record(z.string(), z.string()).nullable(),
	allowedParameterFields: z.array(z.string()),
	isGeneric: z.boolean(),
	syncedAt: z.iso.datetime().nullable(),
	archivedAt: z.iso.datetime().nullable(),
})

export type WhatsAppTemplateDataSchema = z.infer<typeof whatsAppTemplateDataSchema>
